module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.99088652.jpg";